import React from 'react';
import { Brain } from 'lucide-react';
import CognitiveBiasPage from '../../pages/prioritization/insights/CognitiveBiasPage';

export const CognitiveBiasLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <Brain className="h-8 w-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Cognitive Bias Audit (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm max-w-2xl mx-auto">
          AI-assisted bias detection across your cycle or session — see how cognitive biases manifest
          in actual prioritization work before you commit.
        </p>
      </div>
      <CognitiveBiasPage />
    </div>
  );
};
